<title>{{ operationalAssurancesKPIDefinitionsPage.htmlTitle }}</title>
<app-operational-assurances-table-section [tableSections]="operationalAssurancesKPIDefinitionsPage.tableSection"> </app-operational-assurances-table-section>
